import { cn } from '@/utils/cn';

interface AspectRatioSelectorProps {
  options: readonly string[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export function AspectRatioSelector({ options, value, onChange, label }: AspectRatioSelectorProps) {
  const getAspectRatioSize = (ratio: string) => {
    switch (ratio) {
      case '9:16': return { width: 36, height: 64 };
      case '16:9': return { width: 64, height: 36 };
      case '1:1': return { width: 50, height: 50 };
      default: return { width: 56, height: 42 }; // auto
    }
  };

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-3">
          {label}
        </label>
      )}
      <div className="flex flex-wrap gap-4">
        {options.map((option) => {
          const size = getAspectRatioSize(option);
          const isSelected = value === option;
          
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className="flex flex-col items-center gap-2"
            >
              <div
                className={cn(
                  'flex items-center justify-center rounded-lg border-2 transition-all',
                  isSelected
                    ? 'border-primary bg-primary/10'
                    : 'border-glass-border hover:border-primary/30'
                )}
                style={{ width: size.width, height: size.height }}
              >
                <span className={cn(
                  'text-xs font-medium',
                  isSelected ? 'text-primary' : 'text-text-secondary'
                )}>
                  {option}
                </span>
              </div>
              <div className={cn(
                'w-4 h-4 rounded-full border-2 flex items-center justify-center',
                isSelected ? 'border-primary bg-primary' : 'border-text-tertiary'
              )}>
                {isSelected && <div className="w-2 h-2 rounded-full bg-white" />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

